import {ActionService} from "../../../../../opportunity_actions_service/service/ActionService";
import {OpportunityAction} from "../../../../model/OpportunityAction";
import {ToastNotificationService} from "../../../../../utils/ToastNotificationService";
import * as angular from "angular";
import {IHttpPromise, IPromise} from "angular";
import {Opportunity} from "../../../../../opportunities/model/Opportunity";
import {ActionComponent, ActionComponentScope} from "../../action.component";
import {ActionStatus} from "../../../../../action_status/model/ActionStatus";
import {ActionTypes} from "../../../../../action_status/model/ActionType";
import {PreviewContentType} from "../../../help/model/PreviewContentType";
import {UserGranredAuthorityName} from "modules/router/const/AllPermitions";
import {
    SmsClarificationDialog
} from "modules/opportunity_actions/components/action_components/actions/sms_dialog/SmsClarificationDialog";

interface SendSmsActionScope extends ActionComponentScope {
}

export class SendSmsAction extends ActionComponent {

    static instance = () => ActionComponent.instance(SendSmsAction);

    constructor($scope: SendSmsActionScope,
                actionService: ActionService,
                $exceptionHandler: ng.IExceptionHandlerService,
                $mdDialog: angular.material.IDialogService,
                toastService: ToastNotificationService) {
        super($scope, actionService, $exceptionHandler, $mdDialog, toastService);
    }

    protected $scope: SendSmsActionScope;

    sendSms = (): IHttpPromise<OpportunityAction[]> => {

        let opportunity = this.$scope.opportunity;

        return this.actionService.sendActionRequest(
            opportunity.id, this.getOpportunityAction(opportunity));

    };

    sendDirrectSms = () : any => {
        let opportunity = this.$scope.opportunity;
        return  this.actionService.sendSmsRequest(opportunity.id)
            .then((response: any) => {
                const smsText = response.data.smsUrl
                const phoneNumber = response.data.phoneNumber
                const smsUrl = `sms:${phoneNumber}?body=${encodeURIComponent(smsText)}`;
                window.location.href = smsUrl;
            }).catch((error: any) => {
            console.error("Failed to send SMS:", error);
        });
    }

    private getOpportunityAction(opportunity: Opportunity): OpportunityAction {
        return {
            actionType: this.getActionType(),
            customerId: opportunity.customer.id,
            calculatorId: opportunity.calculator.id,
            calculationExecutionLogId: opportunity.id,
            status: ActionStatus.NEW,
        };
    }

    protected executeAction: () =>
        IPromise<angular.IHttpResponse<OpportunityAction[]>> = () => {
        const instance = SmsClarificationDialog.instance;
        return this.$mdDialog.show(instance).then((chosenMethod: 'DIRECT_SMS' | 'EXTERNAL_SMS') => {
            if (chosenMethod === 'DIRECT_SMS') {
                return this.sendDirrectSms();
            } else {
                return this.sendSms();
            }
        });
    };

    protected getActionType = () => ActionTypes.TWILIO_SMS;

    protected getTitle = () => "Send SMS";

    protected getIcon = () => "/app/images/icons/sms.svg";

    protected getErrorMessage = () => {
        return "Sms wasn't sent";
    };

    protected getSuccessMessage = () => {
        return "Sms sent";
    };

    protected isDisabled(opportunity: Opportunity): boolean {
        return super.isDisabled(opportunity) || !opportunity.customer.isSmsDeliverable || !this.hasAccessToSms();
    }

    private hasAccessToSms(): boolean {
        return  this.principle.userAccessLevels.find(f => f.authorityName == UserGranredAuthorityName.SENDING_SMS).status
    }


    protected getTooltipMessage(): string {
        if (this.opportunity.customer.isSmsDeliverable) {
            return super.getTooltipMessage();
        } else {
            return "Customer has no phone number";
        }
    }


    protected getPreviewContentType = (): PreviewContentType => {
        return PreviewContentType.TEXT;
    };
}
